import clsx from "clsx";

export const Fork: React.FC<React.ComponentProps<"button">> = ({
  children,
  className,
  ...props
}) => {
  return (
    <button
      className={clsx(
        "border-2 ring-current transition-all hover:border-current hover:text-secondary focus:active:bg-base-200 disabled:border-current disabled:text-base-300 aria-selected:border-current aria-selected:text-accent aria-selected:ring-2 aria-selected:ring-current",
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
};
